export enum EDraggableEntity {
  BOOKING_CARD = "BOOKING_CARD",
  BOOKING_TABLE = "BOOKING_TABLE",
  TABLE_TEMPLATE = 'TABLE_TEMPLATE',
}
